import { required, integer } from '@vuelidate/validators'

export const CreateSLAValidation = {
    city_from: { required },
    city_to: { required },
    pickup: { required, integer },
    processing: { required, integer },
    transit: { required, integer },
    delivery: { required, integer },
    tariff: { required },
}
